import { createSlice } from "@reduxjs/toolkit";
import {
  addMemberToOrganizationBuilder,
  addNewOrganizationBuilder,
  editOrganizationMemberDescriptionBuilder,
  fetchUserInfoBuilder,
  getOrganizationMembersBuilder,
  getUserMemberWishlistItemsBuilder,
  loginBuilder,
  removeItemFromWishlistBuilder,
  removeMemberBuilder,
  removeOrganizationBuilder,
  searchUsersBuilder,
  setActiveUserOrganizationBuilder,
  setOrganizationDescriptionBuilder,
  setOrganizationLogoBuilder,
  setPriorityToOrganizationMembersBuilder,
  setPriorityToOrganizationsBuilder,
  signUpOrganizationBuilder,
  updateItemBuilder,
} from "./builder";

const initialState = {
  organizationUser: {
    id: null,
    email: "",
    phoneNumber: "",
    firstName: "",
    lastName: "",
    activeOrganizationId: null,
    organizationName: "",
    organizationPhotoUrl: "",
    description: "",
  },

  allUserOrganizations: [],
  organizationMembers: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },
  searchUsers: {
    data: [],
    maxReached: false,
    total: 0,
    page: 1,
  },

  userWishlistItems: [],

  fetchUserInfoPending: false,
  setOrganizationDescriptionPending: false,
  setOrganizationLogoPending: false,
  setActiveUserOrganizationPending: false,
  getOrganizationMembersPending: false,
  addMemberToOrganizationPending: false,
  getUserMemberWishlistItemsPending: false,
  removeItemFromWishlistPending: false,
  addNewOrganizationPending: false,
  removeOrganizationPending: false,
  removeMemberPending: false,
  updateItemPending: false,
  searchUsersPending: false,
  setPriorityToOrganizationMembersPending: false,
  setPriorityToOrganizationsPending: false,
  editOrganizationMemberDescriptionPending: false,
};

export const organizationSlice = createSlice({
  name: "organization",
  initialState,
  reducers: {
    resetOrganizationMembers(state) {
      state.organizationMembers = {
        data: [],
        maxReached: false,
        total: 0,
        page: 1,
      };
    },

    resetUserWishlistItems(state) {
      state.userWishlistItems = [];
    },

    resetSearchUsers(state) {
      state.searchUsers = {
        data: [],
        maxReached: false,
        total: 0,
        page: 1,
      };
    },
  },
  extraReducers: (builder) => {
    fetchUserInfoBuilder(builder);
    setPriorityToOrganizationMembersBuilder(builder);
    setPriorityToOrganizationsBuilder(builder);
    loginBuilder(builder);
    setActiveUserOrganizationBuilder(builder);
    setOrganizationDescriptionBuilder(builder);
    setOrganizationLogoBuilder(builder);
    getOrganizationMembersBuilder(builder);
    searchUsersBuilder(builder);
    addMemberToOrganizationBuilder(builder);
    getUserMemberWishlistItemsBuilder(builder);
    removeItemFromWishlistBuilder(builder);
    signUpOrganizationBuilder(builder);
    addNewOrganizationBuilder(builder);
    removeOrganizationBuilder(builder);
    removeMemberBuilder(builder);
    updateItemBuilder(builder);
    editOrganizationMemberDescriptionBuilder(builder);
    builder.addCase("logout", () => ({ ...initialState, loggedIn: false }));
  },
});

export const {
  resetOrganizationMembers,
  resetUserWishlistItems,
  resetSearchUsers,
} = organizationSlice.actions;
export const selectAllUserOrganizations = (state) =>
  state.organization.allUserOrganizations;
export const selectUserInfo = (state) => state.organization.organizationUser;
export const selectFetchUserPending = (state) =>
  state.organization.fetchUserInfoPending;
export const selectSetActiveUserOrganizationPending = (state) =>
  state.organization.setActiveUserOrganizationPending;

export const selectSetOrganizationLogoPending = (state) =>
  state.organization.setOrganizationLogoPending;
export const selectSetOrganizationDescriptionPending = (state) =>
  state.organization.setOrganizationDescriptionPending;

export const selectOrganizationMembers = (state) =>
  state.organization.organizationMembers;

export const selectSearchUsers = (state) => state.organization.searchUsers;
export const selectGetOrganizationMembersPending = (state) =>
  state.organization.getOrganizationMembersPending;

export const selectAddMemberToOrganizationPending = (state) =>
  state.organization.addMemberToOrganizationPending;

export const selectUserWishlistItems = (state) =>
  state.organization.userWishlistItems;

export const selectGetUserMemberWishlistItemsPending = (state) =>
  state.organization.getUserMemberWishlistItemsPending;

export const selectRemoveItemFromWishlistPending = (state) =>
  state.organization.removeItemFromWishlistPending;

export const selectUpdateItemPending = (state) =>
  state.organization.updateItemPending;
export const selectRemoveMemberPending = (state) =>
  state.organization.removeMemberPending;

export const selectRemoveOrganizationPending = (state) =>
  state.organization.removeOrganizationPending;

export const selectAddNewOrganizationPending = (state) =>
  state.organization.addNewOrganizationPending;

export const selectSearchUsersPending = (state) =>
  state.organization.searchUsersPending;

export const selectEditOrganizationMemberDescriptionPending = (state) =>
  state.organization.editOrganizationMemberDescriptionPending;

export default organizationSlice.reducer;
